import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { hashHistory, Link } from 'react-router';
import { Modal, Input, message, Popconfirm, Spin, Button, Radio, Checkbox, Icon, Slider } from 'antd';
import ReactQiniuModule from '../../../../lib/ReactQiniuModule';
import TextQuestionEditModule from '../archive/TextQuestionEditModule';
import MediaQuestionEditModule from '../archive/MediaQuestionEditModule';
const { TextArea } = Input;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;

export default class ArchiveStoryEditPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    let role = CurrentRoleStore.getCurrentRole();
    this.state = {
      role,
      status: props.location.query.status ? props.location.query.status : "editable",
      warn: props.location.query.warn,
      pageId: parseInt(props.location.query.pageId),
      templateId: parseInt(props.location.query.templateId),
      studentIds: JSON.parse(props.location.query.studentIds),
      studentId: JSON.parse(props.location.query.studentIds)[0],
      archiveId: parseInt(props.location.query.archiveId),
      pageContentId: props.location.query.pageContentId ? parseInt(props.location.query.pageContentId) : null,
      classId: parseInt(props.location.query.classId),
      semester: props.location.query.semester ? props.location.query.semester : SharedTools.getCurrentSemester(),
      studentNameArray: [],
      template: {},
      templateContainerView: {
        width: 550,
        height: 0
      },
      errorMsg: "",
      isShowTextQuestionBox: false,
      isShowMediaQuestionBox: false,
      isShowSubmitOrDraft: false,
      isShowSubmitError: false,
      isShowMediaBox: false,
      selectedArea: {},
      pushAnswer: [],
      detailShow: false,
      submitting: false,

      uploading: false,
      uploadedFiles: [],
      uploadingFiles: [],

      isShowAlbumBox: false,
      data: [],
      semesters: [],
      chooseStoryIds: [],
      loading: false
    };
  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onRolesChange);

    // 处理显示需要上传内容的
    DataService.getStudents(this.state.classId).then((students) => {
      let studentNameArray = [];
      this.state.studentIds.forEach(student_id => {
        let s = students.find(s => s.id == student_id);
        studentNameArray.push(s.full_name);
        this.setState({
          studentNameArray
        })
      });
    }).catch((error) => {
      console.log(error)
    })

    // 多个学生删除模板内容
    if (this.state.studentIds.length > 1) {
      let data = {
        page_id: this.state.pageId,
        student_ids: this.state.studentIds,
      }
      DataService.destroyPageContents(data).then((res) => {
      }).catch((error) => {
        console.log(error);
      });
    }


    let data = {
      class_record_id: this.state.classId,
      semester: this.state.semester
    }
    this.state.pageContentId ? this.getPageContentStories(this.state.pageContentId) : this.searchStory(data)
  }

  searchStory(formData) {
    DataService.searchStory(formData).then((res) => {
      this.setState({
        data: res,
      })
    }).catch((error) => {
      console.log(error);
    });
  }

  getPageContentStories(page_content_id) {
    DataService.getPageContentStories({ page_content_id }).then((res) => {
      let chooseStoryIds = res.map(item => String(item.id));
      this.setState({
        chooseStoryIds
      })
      let data = {
        class_record_id: this.state.classId,
        semester: this.state.semester
      }
      this.searchStory(data)
    }).catch((error) => {
      console.log(error);
    });
  }

  onChangStory(value) {
    this.setState({
      chooseStoryIds: value
    })
  }

  // 处理显示时间
  formatDate(date) {
    date = new Date(date);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '.' + m + '.' + d;
  }

  // 处理显示学生名字
  getStudentName (students) {
    students = students.concat([]);
    var count = students.length;
    if (students.length > 3) {
      var label = students.splice(0, 3).map(function (item) {
        return item.full_name;
      }).join(',');
      return label + '...等共' + count + '人'
    } else {
      var label = students.map(function (item) {
        return item.full_name;
      }).join(',');
      return label + '共' + count + '人'
    }
  }

  // 处理显示图片
  getAlbumCover(url, type = '?imageView2/1/w/120') {
    return (url && url.indexOf('imageView2') < 0 ? url + type : url)
  }

  submitStory() {
    this.setState({
      loading: true
    })
    let data = {
      page_id: this.state.pageId,
      student_ids: JSON.stringify(this.state.studentIds),
      story_ids: this.state.chooseStoryIds
    }
    DataService.batchChangePageContentStory(data).then((res) => {
      message.info("提交成功~", 1);
      this.setState({
        loading: false
      })
      setTimeout(function () { hashHistory.goBack(); }, 1500); 
    }).catch((error) => {
      console.log(error);
      this.setState({
        loading: false
      })
    });
  }

  _showStoryModule() {
    let radioStyle = {
      display: 'flex',
      margin: '10px 30px',
      alignItems: 'center'
    }
    // let album = this.state.albums.find((album) => album.selected);
    return (
      <div className="question-box" style={{width: '700px'}}>
        <div className="question-content">
          <div className="question-title">选择故事</div>
          <CheckboxGroup onChange={this.onChangStory.bind(this)} value={this.state.chooseStoryIds}>
            {this.state.data.map((item) => {
              return (
                <div className="story-box" key={item.id} >
                  <Checkbox style={radioStyle} value={String(item.id)} className="story-checkbox">
                    <img src={this.getAlbumCover(item.segments_info[0].image_url)} className="album-cover" />
                    <div className="story-info">
                      <div className="story-title">{item.title}</div>
                      <div>{this.formatDate(item.record_date)} - {item.all_class_student ? '全班' : this.getStudentName(item.students)}</div>
                    </div>
                  </Checkbox>
                  <div className="story-detail" onClick={(e) => this.showStoryDetail(e, item)}>查看详情</div>
                </div>
              )
            })}
          </CheckboxGroup>
        </div>
        {this.state.data.length > 0 ? <div className="question-footer">
          <Button className="question-footer-btn" onClick={() => this.submitStory()} loading={this.state.loading}>确 认</Button>
        </div> : ''}
      </div>
    )
  }

  /*
    * 显示故事详情
  */ 

  showStoryDetail(e, item) {
    this.setState({
      storyVisible: true,
      storyDetail: item
    })
  }

  _showStoryDetailModal() {
    let { storyDetail } = this.state;
    let students = storyDetail ? storyDetail.students.map(s => s.full_name).join(',') : '';
    return(
      <Modal
        title={storyDetail ? storyDetail.title : ''}
        visible={this.state.storyVisible}
        onCancel={() => this.setState({ storyVisible: false })}
        footer={null}
        wrapClassName="story-modal"
      >
        <div className="author">记录人：{storyDetail ? storyDetail.author.full_name : ''}</div>
        <div className="student-name">记录宝贝：{storyDetail ? (
                                                storyDetail.all_class_student ? '全班' : students
                                              ) : ''}
        </div>
        <div className="date {isArchive ? 'archive-date' : ''}">记录时间：{storyDetail ? this.formatDate(storyDetail.record_date) : ''}</div>
        {storyDetail ? storyDetail.segments_info.map(segment => {
          return (
            <div className="segment-box" style={{ textAlign: 'center' }} key={segment.id} >
              <img src={this.getAlbumCover(segment.image_url, '?imageView2/0/w/350')} style={{width: '300px'}}/>
              <p style={{textAlign: 'left'}}>{segment.text}</p>
            </div>
          )
        }) : ''}
      </Modal>
    )
  }

  render() {
    let mediaAreas = [];
    let TextAreas = [];
    if (this.state.template.areas) {
      this.state.template.areas.forEach((area) => {
        if (area.questionType == "media:Image" || area.questionType == "media:Video" || area.questionType == "media:Audio") {
          mediaAreas.push(area)
        } else {
          TextAreas.push(area)
        }
      })
    }
    return (
      <div className="archive-content-edit-page">
        <div className="archive-edit-container">
          <div className="archive-edit-template-info">
            <div className="archive-edit-template-title">故事模板</div>
            {/* <div className="archive-edit-template-detail" onClick={this.showDetail}>查看模板详情</div> */}
            <div className="archive-edit-template-students">选择宝贝：{this.state.studentNameArray.join('、')}</div>
          </div>
          {this._showStoryModule()}
          {this._showStoryDetailModal()}
        </div>
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ArchiveStoryEditPage.jsx